import dynamic from 'next/dynamic'

export const DynamicFreeItemPromoModal = dynamic(
  () => import('.').then((mod) => mod.FreeItemPromoModal),
  { ssr: false },
)
